import * as types from 'reducer/actionTypes'
import { isEmpty, getTime } from 'script/common';

import RealTime from 'components/monitoring/RealTime';
import Database from 'components/monitoring/Database';
import WebApplication from 'components/monitoring/WebApplication';
import FilterServer from 'components/monitoring/FilterServer';
import DocServer from 'components/monitoring/DocServer';

const initialState = {
	tabs : [
		{
			label : "All",
			component : RealTime
		},
		{
			label : "Database",
			component : Database
		},
		{
			label : "WebApplication",
			component : WebApplication
		},
		{
			label : "FilterServer",
			component : FilterServer
		},
		{
			label : "DocServer",
			component : DocServer
		},
	],

	dataApp: {
		word: "WORD",
		show: "SHOW",
		cell: "CELL",
		common: "COMMON"
	},

	dataKey: {
		app: {
			key:"app",
			name: "App"
		},
		healthCheckTime: {
			key: "healthCheckTime",
			name: "HealthCheckTime"
		},
		errorMessage: {
			key: "errorMessage",
			name: "Error Message"
		},
		docServer: {
			key:"docServer",
			name: "Doc Server"
		},
		docServerAction: {
			key:"docServerAction",
			name: "Doc Server Action"
		},
		filterServer: {
			key: "filterServer",
			name: "Filter Server",
		},
		mongodbGridFS: {
			key: "mongodbGridFS",
			name: "MongoDB GridFS"
		},
		mongodb: {
			key: "mongodb",
			name: "MongoDB"
		},
		redis: {
			key: "redis",
			name: "Redis"
		},
		webApplication: {
			key: "webApplication",
			name: "Web Application"
		}
	},

	word : [],
	show : [],
	cell : [],
	common : [],
	lastData : [],
	
	errorLabel:null,
	error:null
};

export default function monitoring(state = initialState, action){
	switch(action.type){

		case types.FETCH_REALTIME_MONITORING_DATA_SUCCESS :

			return {
				...state,
				word: action.value[state.dataApp.word],
				show: action.value[state.dataApp.show],
				cell: action.value[state.dataApp.cell],
				common: action.value[state.dataApp.common],
				lastData: {
					word: {
						mongodb: action.value[state.dataApp.word][0]?.[state.dataKey.mongodb.key].result,
						webApplication: action.value[state.dataApp.word][0]?.[state.dataKey.webApplication.key].result,
						filterServer: action.value[state.dataApp.word][0]?.[state.dataKey.filterServer.key].result,
						docServer: action.value[state.dataApp.word][0]?.[state.dataKey.docServer.key].result,
						docServerAction: action.value[state.dataApp.word][0]?.[state.dataKey.docServerAction.key].result,
					},
					show: {
						mongodb: action.value[state.dataApp.show][0]?.[state.dataKey.mongodb.key].result,
						webApplication: action.value[state.dataApp.show][0]?.[state.dataKey.webApplication.key].result,
						filterServer: action.value[state.dataApp.show][0]?.[state.dataKey.filterServer.key].result,
						docServer: action.value[state.dataApp.show][0]?.[state.dataKey.docServer.key].result,
						docServerAction: action.value[state.dataApp.show][0]?.[state.dataKey.docServerAction.key].result,
					},
					cell: {
						mongodb: action.value[state.dataApp.cell][0]?.[state.dataKey.mongodb.key].result,
						webApplication: action.value[state.dataApp.cell][0]?.[state.dataKey.webApplication.key].result,
						filterServer: action.value[state.dataApp.cell][0]?.[state.dataKey.filterServer.key].result,
					},
					common: {
						redis: action.value[state.dataApp.common][0]?.[state.dataKey.redis.key].result,
						mongodbGridFS: action.value[state.dataApp.common][0]?.[state.dataKey.mongodbGridFS.key].result,
					},
				}
			}

		case types.SET_STATS_ERRORLABEL :
			return{
				...state,
				errorLabel: action.errorLabel
			}
	
		default:
			return state
	}
}